// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G6Hf_ {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
    height: 100%;
    width: 100%;
}

.d5eSZ {
    gap: 12px;
    padding: 12px;
    padding-left: 20px;
    padding-right: 20px;
}

.hOYgp {
    display: flex;
    flex-direction: row;
    gap: 4px;
    flex: 1;
    min-height: 0;
}

.rHCD4 {
    gap: 12px;
}

._qh2v {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
    height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/commander/CommanderCardsGrid.css"],"names":[],"mappings":"AAAA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB","sourcesContent":[".container {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    height: 100%;\n    width: 100%;\n}\n\n.containerBig {\n    gap: 12px;\n    padding: 12px;\n    padding-left: 20px;\n    padding-right: 20px;\n}\n\n.row {\n    display: flex;\n    flex-direction: row;\n    gap: 4px;\n    flex: 1;\n    min-height: 0;\n}\n\n.rowBig {\n    gap: 12px;\n}\n\n.column {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `G6Hf_`,
	"containerBig": `d5eSZ`,
	"row": `hOYgp`,
	"rowBig": `rHCD4`,
	"column": `_qh2v`
};
export default ___CSS_LOADER_EXPORT___;
